<template>
    <el-dialog title="业绩划分规则详情" :visible.sync="isdetailFlag" left width="1400px" custom-class="custom-class-dialog" :before-close="handleClose" :close-on-click-modal="false">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="业绩划分规则主体" name="1">
                    <div>
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="合同号" v-if="isSPCOrder">
                                <div class="rows">{{ details.DistributeMain_OrdersSN }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="ERP订单号" v-else>
                                <div class="rows">{{ details.DistributeMain_ERPOrderSN }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="电商订单号" v-if="!isSPCOrder">
                                <div class="rows">{{ details.DistributeMain_OrdersSN }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="BPM审核状态">
                                <span :class="details.DistributeMain_BPMStatusName == '已审核' ? 'sucess-status-text' : 'is-status-text '">{{ details.DistributeMain_BPMStatusName }}</span>
                                <el-button class="ml10" type="primary" v-if="details.DistributeMain_BPMStatus > 0 && details.DistributeMain_BPMBizObjectID != ''" @click="searchBpm(details.DistributeMain_BPMBizObjectID)">查询审批情况</el-button>
                            </el-descriptions-item>
                            <el-descriptions-item label="审核状态" v-if="!isSPCOrder">
                                <span :class="details.DistributeMain_Status != 2 ? 'sucess-status-text' : 'is-status-text '">
                                    {{ details.DistributeMain_Status == 0 ? '待审核' : details.DistributeMain_Status == 1 ? '已通过' : details.DistributeMain_Status == 2 ? '未通过' : '' }}
                                </span>
                            </el-descriptions-item>
                            <el-descriptions-item label="计算区间">
                                <span v-if="details.DistributeMain_ValidStartDate">{{ details.DistributeMain_ValidStartDate | formatDate }}至</span>

                                <span v-if="details.DistributeMain_ValidEndDate">{{ details.DistributeMain_ValidEndDate | formatDate }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="办事处">{{ details.DistributeMain_OrdersOfficeCode }}</el-descriptions-item>
                            <el-descriptions-item label="业务员">{{ details.DistributeMain_OrdersOfficeManName }}</el-descriptions-item>
                            <el-descriptions-item label="订单类型" v-if="!isSPCOrder">{{ details.DistributeMain_OrderType == 0 ? '线下' : details.DistributeMain_OrderType == 1 ? '商城' : details.DistributeMain_OrderType == 2 ? '代客下单' : '' }}</el-descriptions-item>
                            
                            <el-descriptions-item label="订单总额">{{ details.DistributeMain_TotalPrice }}</el-descriptions-item>
                            <el-descriptions-item label="工程名称">{{ details.DistributeMain_ProjectName }}</el-descriptions-item>
                            <el-descriptions-item label="客户名称">{{ details.DistributeMain_OrdersCustomerName }}</el-descriptions-item>
                            <el-descriptions-item label="工程所在地">{{ details.DistributeMain_ProjectAddress }}</el-descriptions-item>
                            <el-descriptions-item label="收货地">{{ details.DistributeMain_DeliveryAddress }}</el-descriptions-item>
                            <el-descriptions-item label="业绩划分凭证" v-if="!isSPCOrder">
                                <span class="operation-bar-block" @click="downFile(details.DistributeMain_Attachment)" v-if="details.DistributeMain_Attachment">查看附件</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="业绩划分凭证说明" v-if="!isSPCOrder">{{ details.DistributeMain_Note }}</el-descriptions-item>
                            <el-descriptions-item label="创建时间" >{{ elformatDate(details.DistributeMain_AddTime, 'yyyy-MM-dd hh:mm:ss') }}</el-descriptions-item>
                            <el-descriptions-item label="是否正常" v-if="!isSPCOrder">
                                <span :class="details.DistributeMain_IsInvalid == 0 ? 'sucess-status-text' : 'is-status-text '">{{ details.DistributeMain_IsInvalid == 0 ? '正常' : '异常' }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="审核备注">
                                <span style="color: red">{{ details.DistributeMain_AuditNote }}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="业绩划分规则明细" name="2">
                    <div>
                        <el-table :data="Distribute" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column prop="Distribute_OrderType" label="订单类型" align="center" v-if="!isSPCOrder">
                                <template>
                                    {{ details.DistributeMain_OrderType == 0 ? '线下' : details.DistributeMain_OrderType == 1 ? '商城' : details.DistributeMain_OrderType == 2 ? '代客下单' : '' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Distribute_OfficeCode" label="办事处编码" align="center"></el-table-column>
                            <el-table-column prop="Distribute_OfficeMemberCode" label="业务员编码" align="center"></el-table-column>
                            <el-table-column prop="Distribute_Rate" label="分配比例（%）" align="center">
                                <template v-slot="scope">
                                    <span>{{scope.row.Distribute_Rate}}%</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Distribute_OfficeMemberName" label="业务员名称" align="center" show-overflow-tooltip></el-table-column>
                            <el-table-column label="是否主业务员" align="center">
                                <template v-slot="scope">
                                    <span v-if="scope.row.Distribute_IsMain == 1">主业务员</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="业绩划分规则历史记录" name="3">
                    <div>
                        <el-table :data="newlist" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" :span-method="objectSpanMethod">
                            <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                            <el-table-column prop="ValidStartDate" label="有效日期" align="center" width="120"></el-table-column>
                            <el-table-column prop="ValidEndDate" label="失效日期" align="center" width="120"></el-table-column>
                            
                            <el-table-column prop="OfficeCode" label="办事处编码" align="center" width="120"></el-table-column>
                            <el-table-column prop="OfficeMemberCode" label="业务员编码" align="center" width="120"></el-table-column>
                            <el-table-column prop="Rate" label="分配比例（%）" align="center" width="120"></el-table-column>
                            <el-table-column prop="OfficeMemberName" label="业务员名称" align="center" width="120"></el-table-column>
                            
                            

                            <el-table-column prop="AddTime" label="创建时间" align="center" width="150">
                                <template v-slot="scope">
                                    {{ elformatDate(scope.row.AddTime, 'yyyy-MM-dd hh:mm:ss') }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="CreateName" label="创建人" align="center" width="120" v-if="!isSPCOrder"></el-table-column>
                            <el-table-column prop="AuditStatus" label="审核状态" align="center" width="120">
                                <template v-slot="scope">
                                    <span class="is-status-text">{{ scope.row.AuditStatus }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="AuditNote" label="审核备注" align="center" width="120" show-overflow-tooltip>
                                 <template v-slot="scope">
                                    <span class="is-status-text">{{ scope.row.AuditNote }}</span>
                                </template>
                            </el-table-column>
                           
                            <el-table-column prop="IsMainMember" label="是否主业务员" align="center" width="120"></el-table-column>
                            <el-table-column prop="Attachment" label="业绩划分凭证" align="center" width="120" v-if="!isSPCOrder">
                                <template v-slot="scope">
                                    <span class="operation-bar-block" @click="downFile(scope.row.Attachment, true)" v-if="scope.row.Attachment">查看附件</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Orders_Type" label="订单类型" align="center" width="120" v-if="!isSPCOrder">
                                <template v-slot="scope">
                                    {{ scope.row.name }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
            <el-button @click="handleClose">关闭</el-button>
        </span>
        <BPMExamine :isSwitch="isSwitch" :id="details.DistributeMain_BPMBizObjectID" @setSwitchClose="setSwitchClose" v-if="isSwitch"></BPMExamine>
    </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import BPMExamine from '@/components/BPMExamine';
export default {
    components: {
        BPMExamine
    },
    props: {
        isdetailFlag: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        },
        isSPCOrder: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeNames: ['1', '2', '3'],
            BPMStatuslist: {
                0: '待送审',
                1: '审核中',
                2: '已通过',
                3: '未通过',
                '-1': '送审失败'
            },
            details: {
                DistributeMain_AddTime: '',
                DistributeMain_Attachment: '',
                DistributeMain_AuditNote: '',
                DistributeMain_BPMStatusName: '',
                DistributeMain_BPMBizObjectID: '',
                DistributeMain_BPMNote: '',
                DistributeMain_BPMStatus: 2,
                DistributeMain_CreaterID: 54,
                DistributeMain_DeliveryAddress: '',
                DistributeMain_ERPOrderSN: '',
                DistributeMain_ID: 303,
                DistributeMain_IsInvalid: 0,
                DistributeMain_IsValid: 0,
                DistributeMain_Note: '',
                DistributeMain_OrderType: 0,
                DistributeMain_OrdersCustomerCode: '',
                DistributeMain_OrdersCustomerName: '',
                DistributeMain_OrdersID: 0,
                DistributeMain_OrdersOfficeCode: '',
                DistributeMain_OrdersOfficeManCode: '',
                DistributeMain_OrdersOfficeManName: '',
                DistributeMain_OrdersSN: '',
                DistributeMain_ProjectAddress: '',
                DistributeMain_ProjectName: '',
                DistributeMain_Status: 1,
                DistributeMain_TotalPrice: '',
                DistributeMain_ValidEndDate: '',
                DistributeMain_ValidStartDate: '',
                DistributeMain_OrdersSN: ''
            },
            Distribute: [],
            newlist: [],
            historyList: [],
            isSwitch: false // bpm审核弹窗
        };
    },
    watch: {
        isdetailFlag(newval, oldval) {
            if (newval) {
                this.getOrdersPerformanceDistributeMainByID(this.id);
            }
        }
    },
    mounted() {},
    methods: {
        /*
        获取详情数据
        */
        async getOrdersPerformanceDistributeMainByID(id) {
            let res;
            if (this.isSPCOrder) {
                res = await this.$newsApi.getSPCOrdersPerformanceDistributeMainByID({ id });
            } else {
                res = await this.$newsApi.getOrdersPerformanceDistributeMainByID({ id });
            }
            let details = {};
            if (res.data.Resultcode == 0) {
                details = res.data.data;
                const res1 = await this.$newsApi.common.getOrdersBPMAuditStatus({ status: details.DistributeMain_BPMStatus });
                if (res1.data.Resultcode == 0) {
                    details.DistributeMain_BPMStatusName = res1.data.data;
                    this.details = details;
                }
                let res2;
                if (this.isSPCOrder) {
                    res2 = await this.$newsApi.getSPCOrdersPerformanceDistributeDetail({ MainID: details.DistributeMain_ID });
                } else {
                    res2 = await this.$newsApi.getOrdersPerformanceDistributeDetail({ MainID: details.DistributeMain_ID });
                }
                if (res2.data.Resultcode == 0) {
                    this.Distribute = res2.data.data;
                    console.log(res2.data.data, '=========');
                }
                let res3;
                if (this.isSPCOrder) {
                    res3 = await this.$newsApi.getSPCOrdersPerformanceDistributeHistory({ MainID: details.DistributeMain_ID });
                } else {
                    res3 = await this.$newsApi.getOrdersPerformanceDistributeHistory({ MainID: details.DistributeMain_ID });
                }
                if (res3.data.Resultcode == 0) {
                    this.historyList = res3.data.data;
                    const historyList = cloneDeep(this.historyList);
                    this.newlist = [];
                    historyList.forEach((item) => {
                        // 检查 OfficeMember 是否存在且长度大于 0
                        if (item.OfficeMember && item.OfficeMember.length > 1) {
                            item.rowspan = item.OfficeMember.length;
                            item.name = item.Orders_Type;
                            // 遍历 OfficeMember 并生成新条目
                            item.OfficeMember.forEach((el, ix) => {
                                const newItem = ix === 0 ? { ...item, flag: true, ...el } : { ...item, flag: false, ...el };
                                console.log(newItem, 'newItemnewItemnewItem');
                                this.newlist.push(newItem);
                            });
                        } else {
                            item.name = item.Orders_Type;
                            // 如果没有 OfficeMember，则直接使用原条目
                            this.newlist.push({ ...item, rowspan: 1, ...item.OfficeMember[0] });
                            console.log(this.newlist, 'newlist');
                        }
                    });
                }
            }
        },
        /*
        关闭详情
        */
        handleClose() {
            this.$emit('handleClose');
        },
        /*
        打开文件
        */
        downFile(par, flag) {
            if (flag) {
                window.open(par);
                return;
            }
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 判断是否为需要合并的列
            let skipColumns = [3,4,5, 6, 7,11];
            if(this.isSPCOrder)
        {
            skipColumns = [3,4,5, 6, 7];
        }
        
            // 仅当当前列索引不在需要跳过的列中时才进行合并
            if (!skipColumns.includes(columnIndex)) {
                if (row.flag) {
                    return {
                        rowspan: row.rowspan,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        // 查看BPM审核
        searchBpm(e) {
            this.isSwitch = true;
        },
        setSwitchClose() {
            this.isSwitch = false;
        }
    }
};
</script>

<style lang="scss" scoped>
/* .hw-content 的样式 */
.hw-content {
    padding: 0 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
</style>
